export default[
  {
    path: "/xc",
    name: "xc",
    component: () => import("@/views/xcSite/layout"),
    redirect: "/xc/index",
    meta:{
      theme:true
    },
    children:[
      {
        path: "/xc/index",
        name: "xcIndex",
        meta:{
          theme:true
        },
        component: () => import("@/views/xcSite/index"),
      },
      {
        path: "/xc/activity",
        name: "xcActivity",
        meta:{
          theme:true
        },
        component: () => import("@/views/xcSite/activityList"),
      },
      {
        path: "/xc/course",
        name: "xcCourse",
        meta:{
          theme:true
        },
        component: () => import("@/views/xcSite/courseList"),
      },
      {
        path: "/xc/students",
        name: "xcStudents",
        meta:{
          theme:true
        },
        component: () => import("@/views/xcSite/studentsList"),
      },
      {
        path: "/xc/studentsDetail",
        name: "xcStudentsDetail",
        meta:{
          theme:true
        },
        component: () => import("@/views/xcSite/studentsDetail"),
      },
      {
        path: "/xc/school",
        name: "xcSchool",
        meta:{
          theme:true
        },
        component: () => import("@/views/xcSite/schoolList"),
      },
      {
        path: "/xc/schoolDetail",
        name: "xcSchoolDetail",
        meta:{
          theme:true
        },
        component: () => import("@/views/xcSite/schoolDetail"),
      },
      {
        path: "/xc/detail",
        name: "xcDetail",
        meta:{
          theme:true
        },
        component: () => import("@/views/xcSite/detail"),
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/xcSite.js